<template>
  <div>
    <Navigation />
    <section class="section__container top__container blog__details">
      <h1 class="title center__text">
        <strong
          >SMS Enrichi</strong
        >
      </h1>
      <h2 class="title center__text">
        <strong
          >Concevez des pages de destination convertissantes et partagez-les via des liens courts</strong
        >
      </h2>
      <p>
        Le SMS Enrichi est un complément au message SMS traditionnel : il vous permet d'insérer un <strong>lien 
        court</strong> "cliquable" directement dans le corps de votre SMS, redirigeant vers une page mobile contenant 
        un contenu web. Cette combinaison de SMS et de lien web est communément appelée SMS 2.0.
      </p>
      <p>
        L'ajout d'un lien dans votre message surprendra votre public et dynamisera votre campagne SMS. 
        La dimension plus interactive du message enrichi vous aidera également à améliorer vos conversions !
      </p>
      <h2 class="center__text">À quel moment et comment utiliser le SMS Enrichi ?</h2>
      <p>
        Le SMS enrichi est un outil incontournable pour vos initiatives commerciales. L'ajout d'un lien dans 
        le corps du message SMS vous permettra de diriger votre public cible vers votre site web.
      </p>
      
      <h2 class="center__text">
        Quelques cas d’usage du SMS enrichi :
      </h2>
    </section>
    <div class="cards sixty__container">
      <div class="card">
        <img class="card__image"
          src="/../images/enrich/icone-codepromo.png"
          alt=""
          srcset=""
        />
        <div class="card__details center__text">
          <h3 class="title">Promotion de produits </h3>
          <p>
          Transmettez un SMS enrichi avec un lien vers une page web détaillant les offres spéciales de vos produits,
          permettant aux destinataires de les visualiser et d'effectuer des achats directement.
          </p>
        </div>
        </div>
        <div class="card">
          <img
          class="card__image"
            src="/../images/enrich/icone-formulaire.png"
            alt=""
            srcset=""
          />
          <div class="card__details center__text">
            <h3 class="title">Invitez à des événements </h3>
            <p>
              Envoyez des SMS enrichis contenant des liens vers des pages d'inscription ou des invitations
              en ligne pour des événements spéciaux tels que des conférences, des webinaires ou des offres exclusives.
            </p>
          </div>
        </div>
        <div class="card">
          <img
          class="card__image"
            src="/../images/enrich/icone-video.png"
            alt=""
            srcset=""
          />
          <div class="card__details center__text">
            <h3 class="title">Collecte de données  </h3>
            <p>
              Incitez les destinataires à remplir des formulaires en ligne ou à répondre à des enquêtes
              en utilisant des SMS enrichis. Le lien inclus dans le SMS les redirige vers une page où ils peuvent facilement saisir les informations demandées.
            </p>
          </div>
        </div>
    
      </div>
      <div class="sixty__container two__cards">

            <div class="card">
          <img
          class="card__image"
            src="/../images/enrich/icone-facebook.png"
            alt=""
            srcset=""
          />
         <div class="card__details center__text">
          <h3 class="title">Offres promotionnelles </h3>
          <p>
            Transmettez des SMS enrichis avec des liens vers des coupons ou des codes promotionnels exclusifs. 
            Les destinataires peuvent cliquer sur le lien pour accéder aux offres spéciales et les utiliser lors de leurs achats.
          </p>
         </div>
        </div>
        <div class="card">
          <img  class="card__image" src="/../images/enrich/icone-stat-campagne.png" alt="" />
          <div class="card__details center__text">
            <h3 class="title">Sondages et votes </h3>
            <p>
              Invitez les destinataires à participer à des sondages ou à des votes en ligne via des SMS enrichis. 
              Les liens inclus dans le SMS les dirigent vers des pages où ils peuvent partager leurs opinions ou leurs choix.
            </p>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  
</template>

<script>
import Navigation from "./Navigation";
import Footer from "./Footer";
export default {
  components: {
    Navigation,
    Footer,
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";

.card {
  border-radius: 0.25rem;
  box-shadow: 0 20px 40px -14px rgba(0, 0, 0, 0.25);
}
.cards{
    margin-bottom: 2rem;
}

@media(min-width:64rem){
  .top__container{
  margin-top:10rem;
 }
}
</style>
